import React, { useState, useContext, useEffect, useRef } from 'react';
import { UserContext } from '../contexts/userContext';
import { useHistory } from 'react-router';
import request from '../../services/Request';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import BackButton from '../items/buttons/BackButton';
import AddCircleOutlineSharpIcon from '@mui/icons-material/AddCircleOutlineSharp';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import AddIcon from '@mui/icons-material/Add';
import LanguageSharpIcon from '@mui/icons-material/LanguageSharp';
import LoadingIcon from '../items/buttons/LoadingIcon';
import ComputerIcon from '@mui/icons-material/Computer';
import AppsIcon from '@mui/icons-material/Apps';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import Swal from 'sweetalert2';
import {
  Autocomplete,
  Checkbox,
  TextField,
  FormControlLabel,
  Radio,
  RadioGroup,
  IconButton,
  Tooltip,
  Grid,
  Button,
  Box,
  Paper,
  Typography,
  Chip,
  alpha,
  Stack,
  Divider,
  Card,
  CardContent,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PlanoModal from '../../planogram/PlanoModal';
import PaletteIcon from '@mui/icons-material/Palette';
import UpdateLanguages from '../machines/UpdateLanguages';
import GifIcon from '@mui/icons-material/Gif';
import SSmodal from '../machines/SSmodal';
import MachineUIModal from '../machines/MachineUIModal';
import ReceiptModal from '../machines/ReceiptModal';
import { userLimits } from './uitls/userLimits';
import AddressModal from '../machines/AddressModal';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import AlertModal from '../machines/AlertModal';
import moment from 'moment';
import MachineConfig from '../machines/MachineConfig';
import { PermDataSettingOutlined } from '@mui/icons-material';
import BusinessIcon from '@mui/icons-material/Business';
import StopSale from '../machines/StopSale';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ModernTable from './components/ModernTable';
import FilterListIcon from '@mui/icons-material/FilterList';
import DisableMachineModal from '../machines/DisableMachineModal';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

function validateEmail(email) {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

const getGroupsURL = `/groupsAndMachines/`;

export default function ViewMyMachines(props) {
  const theme = useTheme();
  const { setFiltered, filterd, setTestMode, userEmail } = useContext(UserContext);
  let history = useHistory();
  const [modalUI, showModalUI] = useState(false);

  const { id, tableTitle, superAdmin, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Machines',
    'edit_machine'
  );

  const [reflesh, setReflesh] = useState(false);
  const [machines, setMachines] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [showL, setShowL] = useState(false);
  const [showI, setShowI] = useState(false);
  const [showAddress, setShowAddress] = useState(false);
  const [showE, setShowE] = useState(false);
  const [check, setCheck] = useState(false);
  const [radio, setRadio] = useState(() => {
    return localStorage.getItem('machineradio') || 'a';
  });
  const [showAlert, setShowAlert] = useState(false);
  const [sc, setsc] = useState(false);

  const [mConfig, setmConfig] = useState(false);
  const [showDisable, setShowDisable] = useState(false);

  const [isReady, setIsReady] = useState(false);
  const isFirstRender = useRef(true);

  const user = JSON.parse(localStorage.getItem('user'));
  const theme1 = JSON.parse(localStorage.getItem('user'))?.theme === '1';
  const extra = user?.features?.extra;

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_mc') ? localStorage.getItem('table_view_mc') : 10
  );

  useEffect(() => {
    localStorage.setItem('table_view_mc', pagination.toString());
  }, [pagination]);

  function bytesToMegabytes(bytes) {
    return bytes / (1024 * 1024);
  }

  // useEffect(() => {
  //   console.log('GROUPv', localStorage.getItem('groupv'));
  // }, [groupV]);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    } else {
      if (radio === 'a') {
        // console.log('222');
        localStorage.setItem('groupv', []);
        localStorage.setItem('machineradio', 'a');
        setFiltered(machines);
      }
    }
  }, [radio]);

  useEffect(() => {
    let isCancelled = false;
    setCheck(false);
    // Don't reset groupV and radio here - they will be restored from localStorage in getGroups()
    // getMyMachines

    function getGroups() {
      request({
        method: 'get',
        url:
          props.match.params.group && superAdmin
            ? getGroupsURL + props.match.params.id
            : getGroupsURL + userEmail + '/trans',
      }).then((res) => {
        if (!isCancelled) {
          console.log('fulldata', res.data);
          setGroups(res.data.groups);
          res.data.machines?.forEach((element) => {
            if (element?.status_info === 'Out Of Service') {
              element.oos = 'NO';
            }
            element.online = 'false';
            if (element.active) {
              const diff = new Date().getTime() - new Date(element.active);
              if (diff <= 90000) {
                element.online = 'true';
                if (element?.status_info === 'Out Of Service' || element?.appStatus === 'false') {
                  element.online = 'oos';
                }
              }
            }
          });
          console.log('localStorage.getItem', localStorage.getItem('groupv'));
          console.log('localStorage.getItem', localStorage.getItem('machineradio'));
          const machineradio = localStorage.getItem('machineradio');

          // Set machines first
          setMachines(res.data.machines);

          if (machineradio && localStorage.getItem('groupv')) {
            console.log('machineradio', machineradio);
            setRadio(machineradio);
            let groupv = [];
            try {
              groupv = JSON.parse(localStorage.getItem('groupv')) || [];
            } catch (e) {
              groupv = [];
            }
            // console.log('123', JSON.parse(localStorage.getItem('groupv')));
            if (machineradio === 'm' && groupv.length > 0) {
              //filter the groupv with res.data.machine
              let newMC = [];
              res.data.machines.forEach((mc) => {
                if (groupv.includes(mc._id)) {
                  newMC.push(mc);
                }
              });
              // console.log('newMC', newMC);
              setgroupV(newMC);
              // Also set filtered to the selected machines
              setFiltered(newMC);
              setCheck(true);
            } else if (machineradio === 'g' && groupv.length > 0) {
              let newGroup = [];
              res.data.groups.forEach((group) => {
                if (groupv.includes(group._id)) {
                  newGroup.push(group);
                }
              });
              console.log('newGroup', newGroup);
              setgroupV(newGroup);
              // Filter machines by groups
              const myArray = newGroup.map((e) => e.machineID);
              var merged = [].concat.apply([], myArray);
              merged = merged.filter((e, i, self) => i === self.findIndex((t) => t._id == e._id));
              const filteredArray = [];
              res.data.machines.forEach((e) => {
                merged.findIndex((t) => {
                  if (t._id === e._id) {
                    filteredArray.push(e);
                  }
                });
              });
              setFiltered(filteredArray);
              setCheck(true);
            } else if (machineradio === 'a') {
              // All machines selected
              setgroupV([]);
              setFiltered(res.data.machines);
              setCheck(true);
            } else {
              // Reset to defaults if no valid groupv
              setgroupV([]);
              setFiltered(res.data.machines);
            }
            // console.log('groupvvvv');
          } else {
            // No saved state, use defaults
            setRadio('a');
            setgroupV([]);
            setFiltered(res.data.machines);
          }
          console.log('234');
          setLoading(true);
        }
      });
    }

    getGroups();

    return () => {
      setGroups([]);
      isCancelled = true;
    };
  }, []);

  useEffect(() => {
    // console.log('reflesh');
    setIsReady(true);
  }, [radio, groupV]);

  const updateMachine = async (id, description, name, tax) => {
    setLoading(false);
    let data = new FormData();
    data.append('description', description);
    data.append('tax', tax);
    data.append('name', name);
    // data.append('location', location);
    // data.append('email', email);
    // data.append('phone', phone);
    request({
      method: 'post',
      url: `${process.env.REACT_APP_SERVER_API}/machines/edit/${id}`,
      data: data,
    }).then((res) => {
      Swal.fire({
        text: `The machine has been successfully updated`,
        icon: 'success',
      });
      setMachines(res.data);
      setLoading(true);
      reflesh ? setReflesh(false) : setReflesh(true);
    });
  };

  const deleteMachine = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    }).then((result) => {
      if (result.isConfirmed) {
        request({
          method: 'delete',
          url: `${process.env.REACT_APP_SERVER_API}/machines/delete/${id}`,
        }).then((res) => {
          Swal.fire('Deleted!', 'Your file has been deleted.', 'success');
          reflesh ? setReflesh(false) : setReflesh(true);
        });
      }
    });
  };

  const handleDisable = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will be applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setShowDisable(true);
        }
      });
    } else if (filterd.length === 1) {
      setShowDisable(true);
    }
  };

  const handleChange = async (event) => {
    setCheck(true);
    setIsReady(false);
    if (radio === 'a') {
      setFiltered(machines);
    }
    if (radio === 'g') {
      localStorage.setItem('groupv', JSON.stringify(groupV.map((e) => e._id)));
      localStorage.setItem('machineradio', 'g');
      const myArray = groupV.map((e) => e.machineID);
      var merged = [].concat.apply([], myArray);
      merged = merged.filter((e, i, self) => i === self.findIndex((t) => t._id == e._id));
      // const filteredArray = machines.filter((e, i) => i == merged.findIndex((t)=>(t._id == e._id)));
      const filteredArray = [];
      console.log(merged);
      machines.forEach((e) => {
        merged.findIndex((t) => {
          if (t._id === e._id) {
            filteredArray.push(e);
          }
        });
      });
      setFiltered(filteredArray);
    }
    if (radio === 'm') {
      localStorage.setItem('groupv', JSON.stringify(groupV.map((e) => e._id)));
      localStorage.setItem('machineradio', 'm');
      if (groupV.length > 0) {
        const array = [];

        groupV.forEach((groupItem) => {
          const machineItem = machines.find((machine) => machine._id === groupItem._id);
          if (machineItem) {
            array.push(machineItem);
          }
        });
        console.log('array', array);
        // console.log('array[0]', array);
        //check is address.full_address entered before applying
        setFiltered(array);
        if (groupV.length === 1) {
          if (groupV[0].address && groupV[0].address.full_address) {
          } else {
            Swal.fire({
              title: '🌟 We Need Your Help! 🌟',
              text: '🚀 To make things easier, please provide the full address of this machine. 🌍 Your input is valuable! 🙏',
              icon: 'info', // You can use 'info' for a blue icon
              showCancelButton: true, // This shows the Cancel button
              confirmButtonText: 'Submit Address 📝',
              cancelButtonText: 'Cancel ❌',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#aaa',
            }).then((result) => {
              if (result.isConfirmed) {
                setShowAddress(true);
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                // Handle the cancel action if needed
                console.log('User canceled the address input');
              }
            });
          }
        }
      }
    }
  };

  const handleCate = () => {
    console.log(filterd);
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          history.push(`/dashboard/addCategories/all`);
        }
      });
    } else if (filterd.length == 1) {
      history.push(`/dashboard/addCategories/${filterd[0]._id}`);
    }
  };

  const handleProd = () => {
    const check = filterd.every((v) => v.plano && v.plano !== '');
    if (check) {
      if (filterd.length > 1) {
        Swal.fire({
          title: 'Are you sure?',
          text: 'The action will applied to all of your selected machines.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then((result) => {
          if (result.isConfirmed) {
            history.push(`/dashboard/addProducts/all`);
          }
        });
      } else if (filterd.length == 1) {
        history.push(`/dashboard/addProducts/${filterd[0]._id}`);
      }
    } else {
      Swal.fire({
        text: 'You must select a planogram to machine before edit product.',
        icon: 'error',
      });
    }
  };

  const handleFridge = () => {
    if (filterd.length > 1) {
      Swal.fire({
        icon: 'error',
        title: 'Action Not Allowed',
        text: 'This action is not permitted for the selected machines.',
        confirmButtonColor: '#d33',
        confirmButtonText: 'OK',
      });
    } else if (filterd.length == 1) {
      history.push(`/dashboard/addProductsToFridge/${filterd[0]._id}`);
    }
  };

  const handleBrand = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          history.push(`/dashboard/addBrands/all`);
        }
      });
    } else if (filterd.length == 1) {
      history.push(`/dashboard/addBrands/${filterd[0]._id}`);
    }
  };

  const handlePlano = () => {
    if (filterd.length > 1) {
      const error = filterd.some((e) => {
        return (
          e.model !== filterd[0].model ||
          e.lane !== filterd[0].lane ||
          e.floor !== filterd[0].floor ||
          e.stock !== filterd[0].stock
        );
      });
      if (error) {
        Swal.fire({
          title: 'Error',
          // text: "The machines your select have different stocks/lanes/floors.",
          text: 'The machines your select have different model.',
          icon: 'error',
        });
      } else {
        Swal.fire({
          title: 'Are you sure?',
          text: 'The action will applied to all of your selected machines.',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Yes',
        }).then((result) => {
          if (result.isConfirmed) {
            setShow(true);
          }
        });
      }
    } else if (filterd.length === 1) {
      setShow(true);
    }
  };

  const handleEmail = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          console.log('2223423423');
          setShowE(true);
        }
      });
    } else if (filterd.length === 1) {
      setShowE(true);
    }
  };

  const handleUI = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          showModalUI(true);
        }
      });
    } else if (filterd.length === 1) {
      showModalUI(true);
    }
  };

  const handleLanguage = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setShowL(true);
        }
      });
    } else if (filterd.length === 1) {
      setShowL(true);
    }
  };

  const handleSS = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setShowI(true);
        }
      });
    } else if (filterd.length === 1) {
      setShowI(true);
    }
  };

  const handleAddress = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setShowAddress(true);
        }
      });
    } else if (filterd.length === 1) {
      setShowAddress(true);
    }
  };

  const stopsale = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setsc(true);
        }
      });
    } else if (filterd.length === 1) {
      setsc(true);
    }
  };

  const options = [
    () => ({
      icon: AppsIcon,
      tooltip: 'Machine UI(1080*1920)',
      onClick: (event, rowData) => {
        if (theme1) {
          window.open(
            `${process.env.REACT_APP_MUI1}/machineUI/home/${rowData._id}/true`,
            'mywin',
            'width=1077,height=1920'
          );
        } else if (extra) {
          window.open(
            `${process.env.REACT_APP_MUI}/machineUI/home/${rowData._id}/true`,
            'mywin',
            'width=1077,height=1920'
          );
        } else {
          window.open(
            `${process.env.REACT_APP_MUI2}/machineUI/home/${rowData._id}/true`,
            'mywin',
            'width=1077,height=1920'
          );
        }

        // history.push(`/machineUI/home/${rowData._id}/true`);
      },
    }),
    () => {
      if (superAdmin)
        return {
          icon: 'delete',
          tooltip: 'Machine Transaction',
          onClick: (event, rowData) => {
            deleteMachine(rowData._id);
          },
        };
    },
    // () =>(
    //   {
    //     icon: ComputerIcon,
    //     tooltip: 'Select Planogram',
    //     onClick: ((event, rowData) => {selectPlano(rowData)})
    //   }
    // ),
    // () =>(
    //   {
    //     icon: PaletteIcon,
    //     tooltip: 'Customize UI',
    //     onClick: ((event, rowData) => selectCustomizeUI(rowData))
    //   }
    // ),
    // () =>(
    //   {
    //     icon: LanguageSharpIcon,
    //     tooltip: 'Update Languages',
    //     onClick: ((event, rowData) => updateLanguages(rowData))
    //   }
    // ),
    // () =>(
    //   {
    //     icon: GifIcon,
    //     tooltip: 'Customized Screen Saver',
    //     onClick: ((event, rowData) => updateSS(rowData))
    //   }
    // ),
  ];

  if (user?.dba) {
    options.push(() => ({
      icon: RemoveRedEyeIcon,
      tooltip: 'Machine UI(Developer Mode View)',
      onClick: (event, rowData) => {
        if (theme1) {
          window.open(`${process.env.REACT_APP_MUI1}/machineUI/home/${rowData._id}/true`);
        } else if (extra) {
          window.open(`${process.env.REACT_APP_MUI}/machineUI/home/${rowData._id}/true`);
        } else {
          window.open(`${process.env.REACT_APP_MUI2}/machineUI/home/${rowData._id}/true`);
        }
      },
    }));
  }

  const handleAlert = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setShowAlert(true);
        }
      });
    } else if (filterd.length === 1) {
      setShowAlert(true);
    }
  };

  const superAdminColumns = [
    {
      title: 'ID',
      field: 'name',
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: theme.palette.primary.main, fontFamily: 'monospace' }}
        >
          {rowData.name}
        </Typography>
      ),
    },
    {
      title: 'Groups',
      render: (rowData) => (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {rowData.group?.map((e, i) => (
            <Chip
              key={i}
              label={e.name}
              size="small"
              sx={{
                fontWeight: 600,
                fontSize: '0.75rem',
                backgroundColor: alpha(theme.palette.secondary.main, 0.12),
                color: theme.palette.secondary.dark,
                border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
              }}
            />
          ))}
        </Box>
      ),
    },
    {
      title: 'Desc',
      field: 'description',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rowData.description}
        </Typography>
      ),
    },
    {
      title: 'Tax',
      field: 'tax',
      type: 'numeric',
      render: (rowData) => (
        <Chip
          label={`${rowData.tax}%`}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.warning.main, 0.12),
            color: theme.palette.warning.dark,
            border: `1.5px solid ${alpha(theme.palette.warning.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Version',
      field: 'version',
      editable: 'never',
      render: (rowData) => (
        <Chip
          label={rowData.version || 'N/A'}
          size="small"
          sx={{
            fontWeight: 600,
            fontFamily: 'monospace',
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Temp℃',
      editable: 'never',
      render: (rowData) => {
        if (rowData.tempData?.curr_temp) {
          let currentTemp = parseInt(rowData.tempData?.curr_temp);
          let targetTemp = parseInt(rowData.tempData?.target_temp);
          let tempRange = parseInt(rowData.tempData?.temp_range);

          if (!targetTemp) {
            if (Array.isArray(rowData.tempData?.curr_temp)) {
              return (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {rowData.tempData?.curr_temp.map((v) => `${v}℃`).join('+')}
                </Typography>
              );
            }
            return (
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {rowData.tempData?.curr_temp}℃
              </Typography>
            );
          }

          let finalString = ``;
          let statusColor = theme.palette.grey[400];
          if (rowData.tempData?.temp_control == '1') {
            finalString = `${currentTemp}-${targetTemp}(${tempRange})`;
            if (currentTemp >= targetTemp - tempRange && currentTemp <= targetTemp + tempRange) {
              statusColor = theme.palette.success.main;
            } else {
              statusColor = theme.palette.error.main;
            }
          } else {
            finalString = rowData.tempData?.curr_temp ? rowData.tempData?.curr_temp : '';
          }

          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StopRoundedIcon sx={{ color: statusColor, fontSize: 16 }} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {finalString}
              </Typography>
            </Box>
          );
        }
        return '-';
      },
    },
    {
      title: 'Status',
      field: 'online',
      editable: 'never',
      render: (rowData) => {
        let statusColor = theme.palette.grey[400];
        let statusText = 'Offline';

        if (rowData.online === 'true') {
          statusColor = theme.palette.success.main;
          statusText = 'Online';
        } else if (rowData.online === 'oos') {
          statusColor = theme.palette.error.main;
          statusText = 'OOS';
        }

        return (
          <Chip
            icon={<StopRoundedIcon sx={{ fontSize: 14, color: `${statusColor} !important` }} />}
            label={statusText}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(statusColor, 0.12),
              color: theme.palette.text.primary,
              border: `1.5px solid ${alpha(statusColor, 0.3)}`,
              '& .MuiChip-icon': {
                color: statusColor,
              },
            }}
          />
        );
      },
    },
    {
      title: 'Free Disk',
      field: 'freedisk',
      editable: 'never',
      render: (rowData) => {
        if (rowData.freedisk) {
          const mb = parseInt(bytesToMegabytes(rowData.freedisk));
          const color = mb < 1000 ? theme.palette.error.main : theme.palette.success.main;
          return (
            <Chip
              label={`${mb} MB`}
              size="small"
              sx={{
                fontWeight: 600,
                backgroundColor: alpha(color, 0.12),
                color:
                  theme.palette.mode === 'dark'
                    ? color
                    : theme.palette.getContrastText(alpha(color, 0.12)),
                border: `1.5px solid ${alpha(color, 0.3)}`,
              }}
            />
          );
        }
        return '-';
      },
    },
    // {
    //   title: 'Last Trans',
    //   field: 'lastTrans',
    //   editable: 'never',
    //   render: (rowData) => {
    //     if (rowData.lastTrans) {
    //       let date = new Date(rowData.lastTrans);
    //       return moment.utc(date).format('MMM Do, h:mm A');
    //     }
    //   },
    // },
  ];

  const columns = [
    {
      title: 'ID',
      field: 'name',
      editable: 'never',
      render: (rowData) => (
        <Typography
          variant="body2"
          sx={{ fontWeight: 600, color: theme.palette.primary.main, fontFamily: 'monospace' }}
        >
          {rowData.name}
        </Typography>
      ),
    },
    {
      title: 'Model',
      field: 'model',
      editable: 'never',
      render: (rowData) => (
        <Chip
          label={rowData.model}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    // {
    //   title: 'Machine model',
    //   field: 'model',
    //   editable: 'never',
    //   render: (rowData) => {
    //     return rowData.stock == 1
    //       ? `${rowData.model} (${rowData.lane}L${rowData.floor}F)`
    //       : `${rowData.model} (${rowData.lane}L${rowData.floor}F * ${rowData.stock} Stocks)`;
    //   },
    // },
    {
      title: 'Groups',
      render: (rowData) =>
        rowData.group?.map((e, i) => {
          const length = rowData.group?.length;
          if (i !== length - 1) {
            return `${e.name}, `;
          } else {
            return e.name;
          }
        }),
    },
    { title: 'Desc', field: 'description' },
    { title: 'Tax', field: 'tax', type: 'numeric', render: (rowData) => `${rowData.tax}%` },
    { title: 'Version', field: 'version', editable: 'never' },
    {
      title: 'Temp℃',
      editable: 'never',
      render: (rowData) => {
        if (rowData.tempData?.curr_temp) {
          let currentTemp = parseInt(rowData.tempData?.curr_temp);
          let targetTemp = parseInt(rowData.tempData?.target_temp);
          let tempRange = parseInt(rowData.tempData?.temp_range);

          if (!targetTemp) {
            if (Array.isArray(rowData.tempData?.curr_temp)) {
              return (
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {rowData.tempData?.curr_temp.map((v) => `${v}℃`).join('+')}
                </Typography>
              );
            }
            return (
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {rowData.tempData?.curr_temp}℃
              </Typography>
            );
          }

          let finalString = ``;
          let statusColor = theme.palette.grey[400];
          if (rowData.tempData?.temp_control == '1') {
            finalString = `${currentTemp}-${targetTemp}(${tempRange})`;
            if (currentTemp >= targetTemp - tempRange && currentTemp <= targetTemp + tempRange) {
              statusColor = theme.palette.success.main;
            } else {
              statusColor = theme.palette.error.main;
            }
          } else {
            finalString = rowData.tempData?.curr_temp ? rowData.tempData?.curr_temp : '';
          }

          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <StopRoundedIcon sx={{ color: statusColor, fontSize: 16 }} />
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {finalString}
              </Typography>
            </Box>
          );
        }
        return '-';
      },
    },
    {
      title: 'Status',
      field: 'online',
      editable: 'never',
      render: (rowData) => {
        let statusColor = theme.palette.grey[400];
        let statusText = 'Offline';

        if (rowData.online === 'true') {
          statusColor = theme.palette.success.main;
          statusText = 'Online';
        } else if (rowData.online === 'oos') {
          statusColor = theme.palette.error.main;
          statusText = 'OOS';
        }

        return (
          <Chip
            icon={<StopRoundedIcon sx={{ fontSize: 14, color: `${statusColor} !important` }} />}
            label={statusText}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(statusColor, 0.12),
              color: theme.palette.text.primary,
              border: `1.5px solid ${alpha(statusColor, 0.3)}`,
              '& .MuiChip-icon': {
                color: statusColor,
              },
            }}
          />
        );
      },
    },
    {
      title: 'Free Disk',
      field: 'freedisk',
      editable: 'never',
      render: (rowData) => {
        if (rowData.freedisk) {
          const mb = parseInt(bytesToMegabytes(rowData.freedisk));
          const color = mb < 1000 ? theme.palette.error.main : theme.palette.success.main;
          return (
            <Chip
              label={`${mb} MB`}
              size="small"
              sx={{
                fontWeight: 600,
                backgroundColor: alpha(color, 0.12),
                color:
                  theme.palette.mode === 'dark'
                    ? color
                    : theme.palette.getContrastText(alpha(color, 0.12)),
                border: `1.5px solid ${alpha(color, 0.3)}`,
              }}
            />
          );
        }
        return '-';
      },
    },
    // {
    //   title: 'Last Trans',
    //   field: 'lastTrans',
    //   editable: 'never',
    //   render: (rowData) => {
    //     if (rowData.lastTrans) {
    //       let date = new Date(rowData.lastTrans);
    //       return moment.utc(date).format('MMM Do, h:mm A');
    //     }
    //   },
    // },
  ];

  const handleMachineConfig = () => {
    if (filterd.length > 1) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'The action will applied to all of your selected machines.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.isConfirmed) {
          setmConfig(true);
        }
      });
    } else if (filterd.length === 1) {
      setmConfig(true);
    }
  };

  // Calculate machine statistics
  const totalMachines = filterd.length;
  const onlineMachines = filterd.filter((m) => m.online === 'true').length;
  const offlineMachines = filterd.filter((m) => m.online === 'false').length;
  const oosMachines = filterd.filter((m) => m.online === 'oos').length;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.02)} 0%, ${alpha(
          theme.palette.secondary.main,
          0.02
        )} 100%)`,
        pt: { xs: 0.8, sm: 1.2, md: 1.6, lg: 2 },
        px: { xs: 1.6, sm: 2.4, md: 3.2, lg: 4 },
        pb: { xs: 1.6, sm: 2.4, md: 3.2, lg: 4 },
      }}
    >
      {!loading && <LoadingIcon />}

      <Paper
        elevation={0}
        sx={{
          p: { xs: 1.6, sm: 2.4, md: 3.2 },
          mb: 2.4,
          borderRadius: 3.2,
          background: `linear-gradient(135deg, ${alpha(
            theme.palette.primary.main,
            0.08
          )} 0%, ${alpha(theme.palette.secondary.main, 0.08)} 100%)`,
          border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
          borderBottom: `3px solid ${theme.palette.primary.main}`,
        }}
      >
        <Stack direction="row" spacing={2.4} alignItems="center" justifyContent="space-between">
          {/* Left side - Title and Description */}
          <Stack direction="row" alignItems="center" spacing={1.6}>
            <Box
              sx={{
                width: 44.8,
                height: 44.8,
                borderRadius: 2.4,
                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: `0 3.2px 16px ${alpha(theme.palette.primary.main, 0.3)}`,
              }}
            >
              <ComputerIcon sx={{ color: 'white', fontSize: 25.6 }} />
            </Box>
            <Box>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 800,
                  fontSize: '1.6rem',
                  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                {tableTitle}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 500, fontSize: '0.7rem' }}
              >
                Manage and monitor your kiosk machines
              </Typography>
            </Box>
          </Stack>

          {/* Right side - Stats Cards (1 row, 4 columns) */}
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, 1fr)',
              gap: 1.6,
              minWidth: 'fit-content',
            }}
          >
            <Paper
              sx={{
                p: 1.2,
                borderRadius: 2.4,
                background: alpha(theme.palette.info.main, 0.08),
                border: `1.6px solid ${alpha(theme.palette.info.main, 0.2)}`,
                transition: 'all 0.3s ease',
                minWidth: 100,
                '&:hover': {
                  transform: 'translateY(-3.2px)',
                  boxShadow: `0 6.4px 19.2px ${alpha(theme.palette.info.main, 0.2)}`,
                },
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 600, mb: 0.4, fontSize: '0.6rem' }}
              >
                Total
              </Typography>
              <Typography
                variant="h4"
                sx={{ fontWeight: 800, color: theme.palette.info.dark, fontSize: '1.4rem' }}
              >
                {totalMachines}
              </Typography>
            </Paper>
            <Paper
              sx={{
                p: 1.2,
                borderRadius: 2.4,
                background: alpha(theme.palette.success.main, 0.08),
                border: `1.6px solid ${alpha(theme.palette.success.main, 0.2)}`,
                transition: 'all 0.3s ease',
                minWidth: 100,
                '&:hover': {
                  transform: 'translateY(-3.2px)',
                  boxShadow: `0 6.4px 19.2px ${alpha(theme.palette.success.main, 0.2)}`,
                },
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 600, mb: 0.4, fontSize: '0.6rem' }}
              >
                Online
              </Typography>
              <Typography
                variant="h4"
                sx={{ fontWeight: 800, color: theme.palette.success.dark, fontSize: '1.4rem' }}
              >
                {onlineMachines}
              </Typography>
            </Paper>
            <Paper
              sx={{
                p: 1.2,
                borderRadius: 2.4,
                background: alpha(theme.palette.error.main, 0.08),
                border: `1.6px solid ${alpha(theme.palette.error.main, 0.2)}`,
                transition: 'all 0.3s ease',
                minWidth: 100,
                '&:hover': {
                  transform: 'translateY(-3.2px)',
                  boxShadow: `0 6.4px 19.2px ${alpha(theme.palette.error.main, 0.2)}`,
                },
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 600, mb: 0.4, fontSize: '0.6rem' }}
              >
                Offline
              </Typography>
              <Typography
                variant="h4"
                sx={{ fontWeight: 800, color: theme.palette.error.dark, fontSize: '1.4rem' }}
              >
                {offlineMachines}
              </Typography>
            </Paper>
            <Paper
              sx={{
                p: 1.2,
                borderRadius: 2.4,
                background: alpha(theme.palette.warning.main, 0.08),
                border: `1.6px solid ${alpha(theme.palette.warning.main, 0.2)}`,
                transition: 'all 0.3s ease',
                minWidth: 100,
                '&:hover': {
                  transform: 'translateY(-3.2px)',
                  boxShadow: `0 6.4px 19.2px ${alpha(theme.palette.warning.main, 0.2)}`,
                },
              }}
            >
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontWeight: 600, mb: 0.4, fontSize: '0.6rem' }}
              >
                OOS
              </Typography>
              <Typography
                variant="h4"
                sx={{ fontWeight: 800, color: theme.palette.warning.dark, fontSize: '1.4rem' }}
              >
                {oosMachines}
              </Typography>
            </Paper>
          </Box>
        </Stack>
      </Paper>

      {/* Filter Section and Action Toolbar - Side by Side */}
      <Grid container spacing={2.4} sx={{ mb: 2.4 }}>
        {/* Filter Section */}
        <Grid item xs={12} lg={7}>
          <Paper
            elevation={0}
            sx={{
              p: 2.4,
              height: '100%',
              borderRadius: 3.2,
              background: alpha(theme.palette.background.paper, 0.8),
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              boxShadow: `0 3.2px 9.6px ${alpha(theme.palette.primary.main, 0.08)}`,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                mb: 1.6,
                color: theme.palette.text.secondary,
                fontSize: '0.85rem',
              }}
            >
              Machine Selection
            </Typography>
            <Grid container spacing={2.4} alignItems="center">
              {/* Filter Type Selection */}
              <Grid item xs={12} md={4}>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    mb: 0.8,
                    display: 'block',
                    color: theme.palette.text.secondary,
                    fontSize: '0.75rem',
                  }}
                >
                  Filter By
                </Typography>
                <RadioGroup
                  name="bg_radio"
                  value={radio}
                  onChange={(e) => {
                    setRadio(e.target.value);
                    setgroupV([]);
                    setCheck(false);
                  }}
                >
                  <FormControlLabel
                    value="a"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                        All Machines
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="g"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                        Groups
                      </Typography>
                    }
                  />
                  <FormControlLabel
                    value="m"
                    control={<Radio size="small" />}
                    label={
                      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                        Machines
                      </Typography>
                    }
                  />
                </RadioGroup>
              </Grid>

              {/* Filter Selection */}
              <Grid item xs={12} md={8}>
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 600,
                    mb: 0.8,
                    display: 'block',
                    color: theme.palette.text.secondary,
                    fontSize: '0.75rem',
                  }}
                >
                  Selection
                </Typography>
                {radio === 'a' && (
                  <TextField
                    variant="outlined"
                    label="All Machines"
                    fullWidth
                    size="small"
                    disabled
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: 3,
                        backgroundColor: alpha(theme.palette.action.hover, 0.05),
                      },
                    }}
                  />
                )}

                {radio === 'g' && (
                  <Autocomplete
                    multiple
                    size="small"
                    value={groupV}
                    options={groups}
                    disableCloseOnSelect
                    onChange={(event, value) => {
                      setgroupV(value);
                      setCheck(false);
                    }}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    )}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Select Groups"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 3,
                          },
                        }}
                      />
                    )}
                  />
                )}

                {radio === 'm' && (
                  <Autocomplete
                    multiple
                    size="small"
                    value={groupV}
                    options={machines}
                    disableCloseOnSelect
                    onChange={(event, value) => {
                      setgroupV(value);
                      setCheck(false);
                    }}
                    isOptionEqualToValue={(option, value) => option._id === value._id}
                    getOptionLabel={(option) => option.name}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.description ? `${option.name}(${option.description})` : option.name}
                      </li>
                    )}
                    fullWidth
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        label="Select Machines"
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: 3,
                          },
                        }}
                      />
                    )}
                  />
                )}

                {/* Submit Button */}
                <Button
                  disabled={(groupV.length == 0 && radio != 'a') || !isReady || !loading}
                  onClick={handleChange}
                  variant="contained"
                  fullWidth
                  sx={{
                    mt: 1.6,
                    borderRadius: 2.4,
                    py: 1.2,
                    textTransform: 'none',
                    fontWeight: 700,
                    fontSize: '0.7rem',
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
                    boxShadow: `0 3.2px 9.6px ${alpha(theme.palette.primary.main, 0.4)}`,
                    '&:hover': {
                      transform: 'translateY(-1.6px)',
                      boxShadow: `0 4.8px 16px ${alpha(theme.palette.primary.main, 0.5)}`,
                    },
                    '&:disabled': {
                      background: alpha(theme.palette.action.disabled, 0.12),
                    },
                    transition: 'all 0.3s ease',
                  }}
                >
                  Apply Filter
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Action Toolbar */}
        <Grid item xs={12} lg={5}>
          <Paper
            elevation={0}
            sx={{
              p: 2,
              height: '100%',
              borderRadius: 3.2,
              background: alpha(theme.palette.background.paper, 0.8),
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              boxShadow: `0 3.2px 9.6px ${alpha(theme.palette.secondary.main, 0.08)}`,
            }}
          >
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                mb: 1.6,
                color: theme.palette.text.secondary,
                fontSize: '0.85rem',
              }}
            >
              Batch Actions
            </Typography>
            {/* First row - Select Planogram and Screen Saver */}
            <Stack direction="row" spacing={1.2} sx={{ mb: 1.2 }}>
              <Button
                onClick={handlePlano}
                disabled={!check}
                variant="contained"
                startIcon={<ComputerIcon />}
                sx={{
                  flex: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  px: 2,
                  py: 0.8,
                  background: check
                    ? `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`
                    : theme.palette.action.disabledBackground,
                  boxShadow: check ? `0 2px 8px ${alpha(theme.palette.primary.main, 0.3)}` : 'none',
                  '&:hover': {
                    background: check
                      ? `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`
                      : theme.palette.action.disabledBackground,
                    transform: check ? 'translateY(-2px)' : 'none',
                    boxShadow: check
                      ? `0 4px 12px ${alpha(theme.palette.primary.main, 0.4)}`
                      : 'none',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Select Planogram
              </Button>
              <Button
                onClick={handleSS}
                disabled={!check}
                variant="contained"
                startIcon={<GifIcon />}
                sx={{
                  flex: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  px: 2,
                  py: 0.8,
                  background: check
                    ? `linear-gradient(135deg, ${theme.palette.warning.main} 0%, ${theme.palette.warning.dark} 100%)`
                    : theme.palette.action.disabledBackground,
                  boxShadow: check ? `0 2px 8px ${alpha(theme.palette.warning.main, 0.3)}` : 'none',
                  '&:hover': {
                    background: check
                      ? `linear-gradient(135deg, ${theme.palette.warning.dark} 0%, ${theme.palette.warning.main} 100%)`
                      : theme.palette.action.disabledBackground,
                    transform: check ? 'translateY(-2px)' : 'none',
                    boxShadow: check
                      ? `0 4px 12px ${alpha(theme.palette.warning.main, 0.4)}`
                      : 'none',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Screen Saver
              </Button>
            </Stack>
            {/* Second row - Customize UI and Edit Products */}
            <Stack direction="row" spacing={1.2} sx={{ mb: 1.2 }}>
              <Button
                onClick={handleUI}
                disabled={!check}
                variant="contained"
                startIcon={<PaletteIcon />}
                sx={{
                  flex: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  px: 2,
                  py: 0.8,
                  background: check
                    ? `linear-gradient(135deg, ${theme.palette.info.main} 0%, ${theme.palette.info.dark} 100%)`
                    : theme.palette.action.disabledBackground,
                  boxShadow: check ? `0 2px 8px ${alpha(theme.palette.info.main, 0.3)}` : 'none',
                  '&:hover': {
                    background: check
                      ? `linear-gradient(135deg, ${theme.palette.info.dark} 0%, ${theme.palette.info.main} 100%)`
                      : theme.palette.action.disabledBackground,
                    transform: check ? 'translateY(-2px)' : 'none',
                    boxShadow: check ? `0 4px 12px ${alpha(theme.palette.info.main, 0.4)}` : 'none',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Customize UI
              </Button>
              <Button
                onClick={handleProd}
                disabled={!check}
                variant="contained"
                startIcon={<AddCircleSharpIcon />}
                sx={{
                  flex: 1,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                  px: 2,
                  py: 0.8,
                  background: check
                    ? `linear-gradient(135deg, ${theme.palette.secondary.main} 0%, ${theme.palette.secondary.dark} 100%)`
                    : theme.palette.action.disabledBackground,
                  boxShadow: check
                    ? `0 2px 8px ${alpha(theme.palette.secondary.main, 0.3)}`
                    : 'none',
                  '&:hover': {
                    background: check
                      ? `linear-gradient(135deg, ${theme.palette.secondary.dark} 0%, ${theme.palette.secondary.main} 100%)`
                      : theme.palette.action.disabledBackground,
                    transform: check ? 'translateY(-2px)' : 'none',
                    boxShadow: check
                      ? `0 4px 12px ${alpha(theme.palette.secondary.main, 0.4)}`
                      : 'none',
                  },
                  transition: 'all 0.3s ease',
                }}
              >
                Edit Products
              </Button>
            </Stack>
            {/* Third row - Icon buttons */}
            <Stack direction="row" spacing={0.8} flexWrap="wrap" useFlexGap sx={{ mt: 2.2 }}>
              <Tooltip title="Edit Categories">
                <span>
                  <IconButton
                    onClick={handleCate}
                    disabled={!check}
                    sx={{
                      borderRadius: 1.6,
                      border: `1.2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                      backgroundColor: check
                        ? alpha(theme.palette.primary.main, 0.08)
                        : 'transparent',
                      width: 35.2,
                      height: 35.2,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.15),
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <AddCircleOutlineSharpIcon
                      sx={{
                        color: check ? theme.palette.primary.main : theme.palette.action.disabled,
                        fontSize: '1rem',
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Edit Products To Fridge">
                <span>
                  <IconButton
                    onClick={handleFridge}
                    disabled={!check}
                    sx={{
                      borderRadius: 1.6,
                      border: `1.2px solid ${alpha(theme.palette.info.main, 0.3)}`,
                      backgroundColor: check ? alpha(theme.palette.info.main, 0.08) : 'transparent',
                      width: 35.2,
                      height: 35.2,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.info.main, 0.15),
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <AddCircleOutlineSharpIcon
                      sx={{
                        color: check ? theme.palette.info.main : theme.palette.action.disabled,
                        fontSize: '1rem',
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Edit Brands">
                <span>
                  <IconButton
                    onClick={handleBrand}
                    disabled={!check}
                    sx={{
                      borderRadius: 1.6,
                      border: `1.2px solid ${alpha(theme.palette.warning.main, 0.3)}`,
                      backgroundColor: check
                        ? alpha(theme.palette.warning.main, 0.08)
                        : 'transparent',
                      width: 35.2,
                      height: 35.2,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.warning.main, 0.15),
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <AddIcon
                      sx={{
                        color: check ? theme.palette.warning.main : theme.palette.action.disabled,
                        fontSize: '1rem',
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Select email template">
                <span>
                  <IconButton
                    onClick={handleEmail}
                    disabled={!check}
                    sx={{
                      borderRadius: 1.6,
                      border: `1.2px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
                      backgroundColor: check
                        ? alpha(theme.palette.secondary.main, 0.08)
                        : 'transparent',
                      width: 35.2,
                      height: 35.2,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.secondary.main, 0.15),
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <MailOutlineIcon
                      sx={{
                        color: check ? theme.palette.secondary.main : theme.palette.action.disabled,
                        fontSize: '1rem',
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Update Languages & Time zone">
                <span>
                  <IconButton
                    onClick={handleLanguage}
                    disabled={!check}
                    sx={{
                      borderRadius: 1.6,
                      border: `1.2px solid ${alpha(theme.palette.success.main, 0.3)}`,
                      backgroundColor: check
                        ? alpha(theme.palette.success.main, 0.08)
                        : 'transparent',
                      width: 35.2,
                      height: 35.2,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.success.main, 0.15),
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <LanguageSharpIcon
                      sx={{
                        color: check ? theme.palette.success.main : theme.palette.action.disabled,
                        fontSize: '1rem',
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Kiosk Address">
                <span>
                  <IconButton
                    onClick={handleAddress}
                    disabled={!check}
                    sx={{
                      borderRadius: 2,
                      border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
                      backgroundColor: check
                        ? alpha(theme.palette.primary.main, 0.08)
                        : 'transparent',
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.15),
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <BusinessIcon
                      sx={{
                        color: check ? theme.palette.primary.main : theme.palette.action.disabled,
                        fontSize: '1rem',
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Email Alert">
                <span>
                  <IconButton
                    onClick={handleAlert}
                    disabled={!check}
                    sx={{
                      borderRadius: 1.6,
                      border: `1.2px solid ${alpha(theme.palette.error.main, 0.3)}`,
                      backgroundColor: check
                        ? alpha(theme.palette.error.main, 0.08)
                        : 'transparent',
                      width: 35.2,
                      height: 35.2,
                      '&:hover': {
                        backgroundColor: alpha(theme.palette.error.main, 0.15),
                        transform: 'scale(1.05)',
                      },
                      transition: 'all 0.2s ease',
                    }}
                  >
                    <AddAlertIcon
                      sx={{
                        color: check ? theme.palette.error.main : theme.palette.action.disabled,
                        fontSize: '1rem',
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
              {(id === 'adrian.pittaway@msccruises.com' ||
                id === 'tianlangwu001@gmail.com' ||
                extra ||
                id === '1234@gmail.com') && (
                <Tooltip title="Schedule Sale">
                  <span>
                    <IconButton
                      onClick={stopsale}
                      disabled={!check}
                      sx={{
                        borderRadius: 2,
                        border: `1.5px solid ${alpha(theme.palette.secondary.main, 0.3)}`,
                        backgroundColor: check
                          ? alpha(theme.palette.secondary.main, 0.08)
                          : 'transparent',
                        '&:hover': {
                          backgroundColor: alpha(theme.palette.secondary.main, 0.15),
                          transform: 'scale(1.05)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <ScheduleIcon
                        sx={{
                          color: check
                            ? theme.palette.secondary.main
                            : theme.palette.action.disabled,
                          fontSize: '1rem',
                        }}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
              {extra && (
                <Tooltip title="Machine Config">
                  <span>
                    <IconButton
                      onClick={handleMachineConfig}
                      disabled={!check}
                      sx={{
                        borderRadius: 2,
                        border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
                        backgroundColor: check
                          ? alpha(theme.palette.info.main, 0.08)
                          : 'transparent',
                        '&:hover': {
                          backgroundColor: alpha(theme.palette.info.main, 0.15),
                          transform: 'scale(1.05)',
                        },
                        transition: 'all 0.2s ease',
                      }}
                    >
                      <PermDataSettingOutlined
                        sx={{
                          color: check ? theme.palette.info.main : theme.palette.action.disabled,
                          fontSize: '1rem',
                        }}
                      />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
              {superAdmin && (
                <Button
                  variant="contained"
                  color="error"
                  startIcon={<StopRoundedIcon />}
                  onClick={handleDisable}
                  disabled={!check}
                  sx={{
                    borderRadius: 1.6,
                    textTransform: 'none',
                    fontWeight: 600,
                    px: 2.4,
                    py: 1,
                    boxShadow: check
                      ? `0 4px 12px ${alpha(theme.palette.error.main, 0.3)}`
                      : 'none',
                    '&:hover': {
                      boxShadow: `0 6px 16px ${alpha(theme.palette.error.main, 0.4)}`,
                      transform: 'translateY(-1px)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  Disable Machines
                </Button>
              )}
            </Stack>
          </Paper>
        </Grid>
      </Grid>

      {/* Modern Table */}
      <ModernTable
        onRowsPerPageChange={setPagination}
        columns={superAdmin ? superAdminColumns : columns}
        data={filterd}
        editable={
          access && {
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve, reject) => {
                setTimeout(() => {
                  updateMachine(newData._id, newData.description, newData.name, newData.tax);
                  resolve();
                }, 1000);
              }),
          }
        }
        actions={options}
        options={{
          actionsColumnIndex: -1,
          pageSize: pagination,
          pageSizeOptions: [10, 20, 50, 100],
        }}
      />

      {/* Back Button */}
      <Box sx={{ mt: 1.6, display: 'flex', justifyContent: 'center' }}>
        <BackButton marginTop={0} marginRight={0} />
      </Box>

      {/* Modals */}
      {filterd.length > 0 && (
        <>
          <MachineUIModal
            setMachines={setMachines}
            show={modalUI}
            onHide={() => showModalUI(false)}
            data={filterd}
            reflesh={+reflesh}
            setRowData={setFiltered}
            setReflesh={setReflesh}
          />
          <UpdateLanguages
            setMachines={setMachines}
            show={showL}
            reflesh={+reflesh}
            setReflesh={setReflesh}
            onHide={() => setShowL(false)}
            setRowData={setFiltered}
            data={filterd}
          />
          <SSmodal
            setMachines={setMachines}
            user={user}
            show={showI}
            showAdmin={access}
            onHide={() => setShowI(false)}
            setRowData={setFiltered}
            rowData={filterd}
          />
          <PlanoModal
            setMachines={setMachines}
            machines={machines}
            showAdmin={access}
            show={show}
            rowData={filterd}
            setRowData={setFiltered}
            onHide={() => setShow(false)}
          />
          <ReceiptModal
            setMachines={setMachines}
            showAdmin={access}
            show={showE}
            rowData={filterd}
            setRowData={setFiltered}
            onHide={() => setShowE(false)}
          />
          <AddressModal
            setMachines={setMachines}
            setLoading={setLoading}
            loading={loading}
            user={user}
            showAdmin={access}
            reflesh={+reflesh}
            setReflesh={setReflesh}
            show={showAddress}
            setRowData={setFiltered}
            data={filterd}
            onHide={() => setShowAddress(false)}
          />
          <AlertModal
            setMachines={setMachines}
            user={user}
            showAdmin={access}
            reflesh={+reflesh}
            setReflesh={setReflesh}
            show={showAlert}
            setRowData={setFiltered}
            data={filterd}
            onHide={() => setShowAlert(false)}
          />
          <MachineConfig
            user={user}
            setMachines={setMachines}
            showAdmin={access}
            reflesh={+reflesh}
            setReflesh={setReflesh}
            show={mConfig}
            setRowData={setFiltered}
            data={filterd}
            onHide={() => setmConfig(false)}
          />
          <StopSale
            setMachines={setMachines}
            showAdmin={access}
            show={sc}
            rowData={filterd}
            setRowData={setFiltered}
            onHide={() => setsc(false)}
            reflesh={+reflesh}
            setReflesh={setReflesh}
          />
          {/* <DisableMachineModal
            setMachines={setMachines}
            show={showDisable}
            data={filterd}
            setRowData={setFiltered}
            onHide={() => setShowDisable(false)}
            reflesh={reflesh}
            setReflesh={setReflesh}
          /> */}
        </>
      )}
    </Box>
  );
}
